// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a4f16a2","453":"28409d30","455":"85ace799","977":"31461845"}[chunkId] + ".chunk.js";
};